import { Button } from '../components/button'
import { defineComponent, reactive, Teleport } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from './state'
import Section from '../components/section'
import { Dialog } from '../components/dialog'
import { PSS, 스키마검사 } from '../config'
import Questions, { Question } from '../components/questions'
import { Spinner } from '../components/spinner'

export default defineComponent({
  name: 'page.stage5',
  setup () {
    const store = useStore()
    const router = useRouter()

    store.initStage(5)

    const pssQuestions: Question[] = PSS.q.map(q => ({
      q,
      a: PSS.labels.map((label, idx) => ({
        label,
        value: String(idx),
      })),
    }))

    const 스키마Questions: Question[] = 스키마검사.q.map(q => ({
      q,
      a: 스키마검사.labels.map((label, idx) => ({
        label,
        value: String(idx),
      })),
    }))

    const state = reactive({
      showInvalidPopup: false,
      loading: false,
    })

    const goToNext = async () => {
      if (store.stageValidity !== true) return

      state.loading = true
      const res = await store.submit1()
      state.loading = false

      if (!res.success) {
        return alert('서버 에러! 관리자에게 문의해주세요')
      }

      if (store.possiblePSS) {
        router.push({
          name: 'stage6',
        })
      } else {
        state.showInvalidPopup = true
      }
    }

    const goToSchemaResult = () => {
      router.push({
        name: 'result',
        query: {
          code: store.schemaResultCode,
        },
      })
    }

    return () => [
      <div class="py-10">
        <Section onlyMobile={false}>
          <div class="text-[#245058] basis-full font-bold text-3xl text-center">
            설문참여를 위해 정보를 입력해주세요
          </div>
        </Section>
        {/* PSS */}
        <Section onlyMobile={false} class="mt-12">
          <div class="text-xl text-center basis-full">
            <div>PSS 검사</div>
            <div class="mt-2 text-base">{PSS.description}</div>
          </div>
        </Section>
        <Section onlyMobile={true}>
          <Questions
            questions={pssQuestions}
            values={store.PSSInputs.map(String)}
            onInput={v => (store.PSSInputs = v.map(Number))}
          />
        </Section>
        {/* 스키마검사 */}
        <Section onlyMobile={false} class="mt-12">
          <div class="text-xl text-center basis-full">
            <div>스키마 검사</div>
            <div class="mt-2 text-base">{스키마검사.description}</div>
          </div>
        </Section>
        <Section onlyMobile={true}>
          <Questions
            questions={스키마Questions}
            values={store.스키마Inputs.map(String)}
            onInput={v => (store.스키마Inputs = v.map(Number))}
          />
        </Section>
        <Section onlyMobile={true}>
          <Button
            class="w-full"
            disabled={!store.stageValidity || state.loading}
            onClick={goToNext}
          >
            <div class="flex justify-center items-center">
              <div class="mr-2">
                <Spinner v-show={state.loading} />
              </div>
              <div>계속</div>
            </div>
          </Button>
        </Section>
      </div>,
      <Teleport to="body">
        <Dialog
          visible={state.showInvalidPopup}
          showCloseButton={true}
          closeOnBackdrop={true}
          onClose={goToSchemaResult}
        >
          <div class="p-8 text-center basis-full">
            참여 가능한 대상이 아닙니다
          </div>
        </Dialog>
      </Teleport>,
    ]
  },
})
